(function () {

    'use strict';
    // eslint-disable-next-line no-extend-native
    Number.prototype.ordinal = function () {
        return this + (
            (this % 10 === 1 && this % 100 !== 11) ? 'st' :
                (this % 10 === 2 && this % 100 !== 12) ? 'nd' :
                    (this % 10 === 3 && this % 100 !== 13) ? 'rd' : 'th'
        );
    };

    /**
     * Gets the magnitude of the number.
     * (adapted from: http://stackoverflow.com/a/23917134)
     * @returns {Number} The denary magnitude.
     */
    // eslint-disable-next-line no-extend-native
    Number.prototype.magnitude = function () {
        const me = this;
        // NOTE we must get the primitive value of the number as type equality
        // (===) fails for (me === 0) in PhantomJS
        const value = me.valueOf();

        if (value === 0) {
            return value;
        }

        return Math.floor(Math.log(Math.abs(me)) / Math.LN10 + 0.000000001);
    };

    /**
     * Gets the number formatted to significant figures.
     * @returns {Number} The number of significant figures.
     **/
    // eslint-disable-next-line no-extend-native
    Number.prototype.toSignificantFigures = function (figures) {
        // http://blog.magnetiq.com/post/497605344/rounding-to-a-certain-significant-figures-in
        const me = this;
        const mult = Math.pow(10, figures - me.magnitude() - 1);
        return Math.round(me * mult) / mult;
    };

}());
